import { Error } from './data';

export class Currency {
    success: true|false;
    results: string;
    error: Error;
    data: CurrencyData[] = [];
}

export class CurrencyData {
    name: string;
    code: string;
    symbol: string;
}